import React from "react";

export default function TransitStep({
  trip,
  onArrivedAtDropoff,
  updating,
  onOpenCancelModal,
}) {
  return (
    <div className="space-y-4">
      <div className="bg-purple-50 border border-purple-200 rounded-2xl p-4 flex items-center justify-between">
        <div>
          <span className="text-xs uppercase font-bold text-purple-700">
            Step 2 of 2
          </span>
          <p className="font-bold text-gray-900 text-sm mt-0.5">
            Deliver to Buyer
          </p>
        </div>
        <div className="w-8 h-8 rounded-full bg-purple-600 text-white flex items-center justify-center font-bold text-sm">
          2
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 p-5 space-y-4 shadow-sm">
        <div>
          <p className="text-xs text-gray-400 font-semibold uppercase">
            Buyer / Drop-off
          </p>
          <p className="font-bold text-gray-900 text-base mt-1">
            {trip.buyer_name}
          </p>
          <p className="text-sm text-gray-600 mt-0.5">{trip.dropoff_address}</p>
          {trip.buyer_phone && (
            <a
              href={`tel:${trip.buyer_phone}`}
              className="inline-flex items-center gap-1.5 text-xs text-purple-600 font-semibold mt-2 bg-purple-50 px-3 py-1.5 rounded-lg border border-purple-200"
            >
              📞 Call Buyer ({trip.buyer_phone})
            </a>
          )}
        </div>

        {trip.cod_enabled && (
          <div className="bg-amber-50 border border-amber-200 p-3.5 rounded-xl flex items-center justify-between">
            <div>
              <p className="text-xs font-bold text-amber-800 uppercase">
                Collect Cash on Delivery
              </p>
              <p className="text-xs text-amber-700 mt-0.5">
                Collect from buyer before handing over parcel
              </p>
            </div>
            <span className="font-bold text-base text-amber-900">
              ${(trip.cod_amount || 0).toFixed(2)}
            </span>
          </div>
        )}

        {trip.delivery_otp && (
          <div className="bg-green-50 border border-green-200 p-3 rounded-xl">
            <p className="text-xs text-green-800 font-semibold">
              🔒 OTP Verification Required
            </p>
            <p className="text-[11px] text-green-700 mt-0.5">
              Ask buyer for 4-digit code upon arrival
            </p>
          </div>
        )}
      </div>

      <button
        onClick={onArrivedAtDropoff}
        disabled={updating}
        className="w-full py-4 rounded-2xl bg-purple-600 text-white font-bold text-base hover:bg-purple-700 active:scale-95 transition-all shadow-md shadow-purple-600/20 disabled:opacity-50"
      >
        {updating ? "Updating..." : "ARRIVED AT DROP-OFF"}
      </button>

      <button
        onClick={onOpenCancelModal}
        className="w-full py-2.5 text-xs text-red-500 hover:text-red-700 font-medium text-center"
      >
        Cannot deliver? Cancel trip
      </button>
    </div>
  );
}
